var _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInJobDeploymentJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 549,
    height: 627,
    viewBox: "0 0 549 627",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 237.608,
    y: 47.0078,
    width: 10.9017,
    height: 205.683,
    transform: "rotate(58.6118 237.608 47.0078)",
    fill: "#415E71"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 481.351,
    y: 461.961,
    width: 9.86926,
    height: 215.24,
    transform: "rotate(58.992 481.351 461.961)",
    fill: "url(#paint0_linear_9_183)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9.85156,
    height: 215.24,
    transform: "matrix(0.515158 -0.857095 -0.857095 -0.515158 242.49 581.326)",
    fill: "url(#paint1_linear_9_183)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 246.233,
    y: 57.807,
    width: 10.4374,
    height: 106.47,
    transform: "rotate(29.9007 246.233 57.807)",
    fill: "#FFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M481 165L486 156.5L396 102.25L306 48L301 56.5L481 165Z",
    fill: "#81A4B1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10.0235,
    height: 107.981,
    transform: "matrix(0.866891 -0.498498 -0.498498 -0.866891 343.075 156.501)",
    fill: "#7C9DAF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 9.60615,
    height: 69.2138,
    rx: 2,
    transform: "matrix(0.86931 -0.494267 -0.494267 -0.86931 183.267 459.732)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 9.70701,
    height: 108.83,
    rx: 2,
    transform: "matrix(0.86931 -0.494267 -0.494267 -0.86931 247.704 571.405)",
    fill: "#FFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 343.127,
    y: 471.244,
    width: 10.108,
    height: 105.889,
    rx: 2,
    transform: "rotate(30.1172 343.127 471.244)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 386.21,
    y: 397,
    width: 9.60615,
    height: 69.2138,
    rx: 2,
    transform: "rotate(29.6214 386.21 397)",
    fill: "#6B8CA3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 9.66913,
    height: 61.4441,
    transform: "matrix(0.872564 -0.4885 -0.4885 -0.872564 384.711 227.052)",
    fill: "#7697A9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 9.80874,
    height: 59.2066,
    transform: "matrix(-0.874348 -0.485299 -0.485299 0.874348 190.636 172.942)",
    fill: "url(#paint2_linear_9_183)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 10.176,
    height: 26.3009,
    rx: 2,
    transform: "matrix(-0.861113 -0.508414 -0.508414 0.861113 138.567 270.987)",
    fill: "#597282"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 453,
    width: 421,
    height: 10,
    fill: "url(#paint3_linear_9_183)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 9.94476,
    height: 26.3009,
    rx: 2,
    transform: "matrix(-0.864884 0.501971 0.501971 0.864884 416.173 265.886)",
    fill: "#7A93A1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 414.57,
    y: 362.636,
    width: 10.176,
    height: 26.3009,
    rx: 2,
    transform: "rotate(-147.366 414.57 362.636)",
    fill: "#4E6474"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 10.2794,
    height: 26.4919,
    rx: 2,
    transform: "matrix(0.849399 -0.527752 -0.527752 -0.849399 130.646 362.736)",
    fill: "#3D5569"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 483,
    y: 164,
    width: 11,
    height: 208,
    transform: "rotate(90 483 164)",
    fill: "#7898A9"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 70,
    width: 10,
    height: 209,
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 70,
    width: 11,
    height: 209,
    fill: "#fff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 349,
    width: 11,
    height: 209,
    fill: "#fff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 164,
    width: 11,
    height: 205,
    transform: "rotate(90 274 164)",
    fill: "#fff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 259.944,
    y: 183,
    width: 10,
    height: 102.756,
    transform: "rotate(58.8546 259.944 183)",
    fill: "#fff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 9.26187,
    height: 102.455,
    transform: "matrix(-0.517211 0.855858 0.855858 0.517211 282.79 182.632)",
    fill: "#7A99AA"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 100.484,
    transform: "matrix(-0.509083 0.860717 0.860717 0.509083 179.887 383.384)",
    fill: "#fff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 364.488,
    y: 384,
    width: 10,
    height: 100.484,
    transform: "rotate(59.3972 364.488 384)",
    fill: "#fff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 489.944,
    y: 184,
    width: 10,
    height: 102.756,
    transform: "rotate(58.8546 489.944 184)",
    fill: "#fff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 102.756,
    transform: "matrix(0.517211 -0.855858 -0.855858 -0.517211 491.944 444.705)",
    fill: "#fff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 368.239,
    y: 254.887,
    width: 10,
    height: 85.5737,
    transform: "rotate(58.8546 368.239 254.887)",
    fill: "#fff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 85.5737,
    transform: "matrix(0.517211 -0.855858 -0.855858 -0.517211 370.239 373.818)",
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 175.975,
    y: 372.562,
    width: 10,
    height: 85.5737,
    transform: "rotate(-120.716 175.975 372.562)",
    fill: "#fff"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 66.1077,
    y: 438.306,
    width: 10,
    height: 85.5737,
    transform: "rotate(-120.716 66.1077 438.306)",
    fill: "#fff"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 85.5737,
    transform: "matrix(-0.517211 0.855858 0.855858 0.517211 176.172 255)",
    fill: "#fff"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 9.58519,
    height: 74.8086,
    transform: "matrix(-0.518766 0.854916 0.854916 0.518766 67.9922 190.315)",
    fill: "#7599A9"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 96,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 40 207)",
    fill: "#6E8D9E"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 9.97455,
    height: 89.9386,
    rx: 3,
    transform: "matrix(-0.877363 0.479828 0.479828 0.877363 55.7512 203)",
    fill: "#fff"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 458.112,
    y: 286.702,
    width: 9.97105,
    height: 90.1936,
    rx: 3,
    transform: "rotate(-150.62 458.112 286.702)",
    fill: "#7C9AA9"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 9.97455,
    height: 89.5986,
    rx: 3,
    transform: "matrix(-0.873922 0.486066 0.486066 0.873922 457.717 338)",
    fill: "url(#paint4_linear_9_183)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 10.1807,
    height: 89.2754,
    rx: 3,
    transform: "matrix(0.874039 0.485855 0.485855 -0.874039 46.8198 416.51)",
    fill: "#fff"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 85.5737,
    transform: "matrix(-0.999987 -0.00507489 -0.00507489 0.999987 156.434 268.051)",
    fill: "#fff"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 10.422,
    height: 85.5737,
    transform: "matrix(-0.999987 -0.00507489 -0.00507489 0.999987 39.8562 328.053)",
    fill: "#fff"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 85.5737,
    transform: "matrix(-0.999987 -0.00507489 -0.00507489 0.999987 398.434 272.051)",
    fill: "#fff"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 509,
    y: 211,
    width: 11,
    height: 206,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.5 72C292.658 72 309 55.8823 309 36C309 16.1177 292.658 0 272.5 0C252.342 0 236 16.1177 236 36C236 55.8823 252.342 72 272.5 72ZM272 53C281.941 53 290 45.3888 290 36C290 26.6112 281.941 19 272 19C262.059 19 254 26.6112 254 36C254 45.3888 262.059 53 272 53Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 213C55.8823 213 72 197.106 72 177.5C72 157.894 55.8823 142 36 142C16.1177 142 0 157.894 0 177.5C0 197.106 16.1177 213 36 213ZM36.5 195C46.165 195 54 187.165 54 177.5C54 167.835 46.165 160 36.5 160C26.835 160 19 167.835 19 177.5C19 187.165 26.835 195 36.5 195Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 484C55.8823 484 72 467.658 72 447.5C72 427.342 55.8823 411 36 411C16.1177 411 0 427.342 0 447.5C0 467.658 16.1177 484 36 484ZM36 465C45.9411 465 54 457.165 54 447.5C54 437.835 45.9411 430 36 430C26.0589 430 18 437.835 18 447.5C18 457.165 26.0589 465 36 465Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513 484C532.882 484 549 467.882 549 448C549 428.118 532.882 412 513 412C493.118 412 477 428.118 477 448C477 467.882 493.118 484 513 484ZM512.5 465C522.165 465 530 457.165 530 447.5C530 437.835 522.165 430 512.5 430C502.835 430 495 437.835 495 447.5C495 457.165 502.835 465 512.5 465Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513 214C532.882 214 549 197.882 549 178C549 158.118 532.882 142 513 142C493.118 142 477 158.118 477 178C477 197.882 493.118 214 513 214ZM512.5 195C522.165 195 530 187.165 530 177.5C530 167.835 522.165 160 512.5 160C502.835 160 495 167.835 495 177.5C495 187.165 502.835 195 512.5 195Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272 627C291.882 627 308 610.882 308 591C308 571.118 291.882 555 272 555C252.118 555 236 571.118 236 591C236 610.882 252.118 627 272 627ZM272 609C281.941 609 290 600.941 290 591C290 581.059 281.941 573 272 573C262.059 573 254 581.059 254 591C254 600.941 262.059 609 272 609Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272 352C292.435 352 309 335.211 309 314.5C309 293.789 292.435 277 272 277C251.565 277 235 293.789 235 314.5C235 335.211 251.565 352 272 352ZM272 333C281.941 333 290 324.717 290 314.5C290 304.283 281.941 296 272 296C262.059 296 254 304.283 254 314.5C254 324.717 262.059 333 272 333Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.5 408C408.792 408 422 394.792 422 378.5C422 362.208 408.792 349 392.5 349C376.208 349 363 362.208 363 378.5C363 394.792 376.208 408 392.5 408ZM393 389C399.075 389 404 384.075 404 378C404 371.925 399.075 367 393 367C386.925 367 382 371.925 382 378C382 384.075 386.925 389 393 389Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393 280C409.569 280 423 266.569 423 250C423 233.431 409.569 220 393 220C376.431 220 363 233.431 363 250C363 266.569 376.431 280 393 280ZM393 261C399.075 261 404 256.075 404 250C404 243.925 399.075 239 393 239C386.925 239 382 243.925 382 250C382 256.075 386.925 261 393 261Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152 279C168.569 279 182 265.792 182 249.5C182 233.208 168.569 220 152 220C135.431 220 122 233.208 122 249.5C122 265.792 135.431 279 152 279ZM152 261C158.075 261 163 256.075 163 250C163 243.925 158.075 239 152 239C145.925 239 141 243.925 141 250C141 256.075 145.925 261 152 261Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.5 408C168.792 408 182 394.792 182 378.5C182 362.208 168.792 349 152.5 349C136.208 349 123 362.208 123 378.5C123 394.792 136.208 408 152.5 408ZM153 389C159.075 389 164 384.075 164 378C164 371.925 159.075 367 153 367C146.925 367 142 371.925 142 378C142 384.075 146.925 389 153 389Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 179,
    r: 14,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 447,
    r: 14,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 316,
    r: 16,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 316,
    r: 16,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 313,
    r: 15,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 443,
    cy: 313,
    r: 15,
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 198,
    cy: 153.5,
    rx: 10,
    ry: 9.5,
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.5,
    cy: 471,
    rx: 10.5,
    ry: 10,
    fill: "#fff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 347.5,
    cy: 471,
    rx: 10.5,
    ry: 10,
    fill: "#fff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 347,
    cy: 152.5,
    rx: 11,
    ry: 10.5,
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_183",
    x1: 488.313,
    y1: 677.821,
    x2: 485.81,
    y2: 461.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395676,
    stopColor: "#7796AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763585,
    stopColor: "#7F9EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A0AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_183",
    x1: 6.94981,
    y1: 215.86,
    x2: 4.44217,
    y2: -0.592667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A9AAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395676,
    stopColor: "#668799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763585,
    stopColor: "#57788D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9_183",
    x1: 4.90437,
    y1: 0,
    x2: 4.90437,
    y2: 59.2066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#374C64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446173"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9_183",
    x1: 62,
    y1: 458,
    x2: 483,
    y2: 458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#314D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479111,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613685,
    stopColor: "#52758C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7696A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9_183",
    x1: 4.98727,
    y1: 0,
    x2: 4.98727,
    y2: 89.5986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#274458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273E56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInJobDeploymentJob);
export default __webpack_public_path__ + "static/media/in-job-deployment-job.de79915eb0db72bdaa2464dc3f489ca1.svg";
export { ForwardRef as ReactComponent };